import React from 'react'

import OrderStatusForm from './components/OrderStatusForm'
import OrderStatusList from './components/OrderStatusList'

const OrderStatus: React.FC = () => {
  return (
    <div className="row">
      <OrderStatusForm />
      <OrderStatusList />
    </div>
  )
}
export default OrderStatus
